function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import React from 'react';
import { Link, useNavigate } from 'react-router';
import { getCurrentLanguage } from './navigation';
/**
 * 언어 코드를 자동으로 추가하는 헬퍼 함수
 */ export var addLanguagePrefix = function(path) {
    // 이미 언어 코드가 포함된 경우나 외부 링크인 경우 그대로 반환
    if (typeof path === 'string') {
        // 외부 링크인 경우
        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }
        // 이미 언어 코드가 포함된 경우 (예: /ko/home)
        var supportedLanguages = [
            'en',
            'ko',
            'ja'
        ];
        var pathSegments = path.split('/').filter(Boolean);
        if (pathSegments.length > 0 && supportedLanguages.includes(pathSegments[0])) {
            return path;
        }
        // 특수 경로들 (언어 코드 불필요)
        var specialPaths = [
            '/login',
            '/auth/',
            '/oauth2/',
            '/payment/',
            '/preview/'
        ];
        if (specialPaths.some(function(special) {
            return path.startsWith(special);
        })) {
            return path;
        }
        // 언어 코드 추가
        var currentLanguage = getCurrentLanguage();
        var cleanPath = path.startsWith('/') ? path : "/".concat(path);
        return "/".concat(currentLanguage).concat(cleanPath);
    }
    // Path 객체인 경우 (pathname, search, hash 등)
    if ((typeof path === "undefined" ? "undefined" : _type_of(path)) === 'object' && path.pathname) {
        var prefixedPathname = addLanguagePrefix(path.pathname);
        return prefixedPathname;
    }
    return path.toString();
};
/**
 * 언어 코드가 자동으로 추가되는 useNavigate 훅
 */ export var useI18nNavigate = function() {
    var navigate = useNavigate();
    return function(to, options) {
        if (typeof to === 'number') {
            // 숫자인 경우 (뒤로가기/앞으로가기) options 없이 전달
            navigate(to);
        } else {
            // 경로인 경우 언어 코드 추가
            var prefixedPath = addLanguagePrefix(to);
            navigate(prefixedPath, options);
        }
    };
};
/**
 * 언어 코드가 자동으로 추가되는 Link 컴포넌트
 */ export var I18nLink = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var to = _param.to, props = _object_without_properties(_param, [
        "to"
    ]);
    var prefixedTo = addLanguagePrefix(to);
    return /*#__PURE__*/ React.createElement(Link, _object_spread({
        ref: ref,
        to: prefixedTo
    }, props));
});
I18nLink.displayName = 'I18nLink';
/**
 * 현재 언어 코드를 반환하는 훅
 */ export var useCurrentLanguage = function() {
    return getCurrentLanguage();
};
/**
 * 언어 변경 함수
 */ export var changeLanguage = function(newLanguage) {
    // localStorage에 언어 저장
    localStorage.setItem('i18nextLng', newLanguage);
    // 현재 경로를 새로운 언어로 변경
    if (typeof window !== 'undefined') {
        var currentPath = window.location.pathname;
        var supportedLanguages = [
            'en',
            'ko',
            'ja'
        ];
        var pathSegments = currentPath.split('/').filter(Boolean);
        // 기존 언어 코드 제거
        if (pathSegments.length > 0 && supportedLanguages.includes(pathSegments[0])) {
            pathSegments.shift(); // 첫 번째 세그먼트(언어 코드) 제거
        }
        // 새 언어 코드로 경로 구성
        var newPath = "/".concat(newLanguage, "/").concat(pathSegments.join('/'));
        window.location.href = newPath;
    }
};
